/**
 * What an import or a Detect add saved while the New Connection dialog stayed open for a draft (Option C, C3): shown on
 * the start view and above the form until the dialog closes.
 */
import { CheckCircle2 } from 'lucide-react';

export function NestedFlowNotice({ notice }: { notice: string | null }) {
  if (!notice) return null;
  return (
    <p className="mb-3 flex items-start gap-2 break-words rounded-md border bg-muted/40 px-3 py-2 text-xs leading-snug" role="status" data-testid="connection-dialog-import-notice">
      <CheckCircle2 className="mt-px h-3.5 w-3.5 shrink-0 text-emerald-600 dark:text-emerald-400" aria-hidden />
      <span className="min-w-0">{notice}</span>
    </p>
  );
}
